import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router';
import {
    GridColDef,
    GridPaginationModel,
    GridRowParams,
} from '@mui/x-data-grid';

import {
    DataGrid,
    DataGridCard,
    dataGridNestedObjectValueGetter,
} from '@barboxx/admin-components';
import { usePaging } from '@barboxx/admin-utils';
import Api from '@barboxx/api';
import { Business } from '@barboxx/models';

const COLUMNS: GridColDef<Business>[] = [
    {
        field: 'id',
        headerName: 'Id',
        width: 50,
    },
    {
        field: 'place.name',
        headerName: 'Name',
        valueGetter: dataGridNestedObjectValueGetter,
        width: 200,
        flex: 1,
    },
    { field: 'active', headerName: 'Active', width: 100 },
    {
        field: 'place.category',
        headerName: 'Type',
        valueGetter: dataGridNestedObjectValueGetter,

        width: 100,
    },
];

interface Props {
    searchString?: string;
}

export function BusinessesTable({ searchString }: Props) {
    const navigate = useNavigate();

    const { page, size, sort, updatePageModel, updateSort } = usePaging();
    const { data, isLoading, error } = useQuery({
        queryKey: ['businesses', page, size, sort, searchString],
        queryFn: () =>
            Api.Businesses.getBusinesses({
                page,
                size,
                sort,
                searchString,
            }),
    });

    const handleChangePageModel = (pageModel: GridPaginationModel) => {
        updatePageModel(pageModel);
    };

    const handleRowClick = (param: GridRowParams) => {
        navigate(`${param.id}`);
    };

    return (
        <DataGridCard>
            <DataGrid
                columns={COLUMNS}
                disableColumnMenu
                disableRowSelectionOnClick
                error={error}
                loading={isLoading}
                onRowClick={handleRowClick}
                paginationModel={{
                    page,
                    pageSize: size,
                }}
                onSortModelChange={updateSort}
                rows={data?.data?.results ?? []}
                onPaginationModelChange={handleChangePageModel}
                rowCount={data?.data?.total ?? 0}
            />
        </DataGridCard>
    );
}
